import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface mediaState {
  isOpen: boolean;
  scorecardUrl?: string | null;
  liveTvUrl?: string | null;
}

const initialState: mediaState = {
  isOpen: false,
  scorecardUrl: null,
  liveTvUrl: null,
};

export const mediaSlice = createSlice({
  name: 'media',
  initialState,
  reducers: {
    openBetslip: (state) => {
      state.isOpen = true;
    },
    closeBetslip: (state) => {
      state.isOpen = false;
    },
    toggleBetslip: (state) => {
      state.isOpen = !state.isOpen;
    },
    setMediaUrls: (state, action: PayloadAction<{ scorecardUrl?: string; liveTvUrl?: string }>) => {
      state.scorecardUrl = action.payload.scorecardUrl;
      state.liveTvUrl = action.payload.liveTvUrl;
    },
  },
});

export const { openBetslip, closeBetslip, toggleBetslip, setMediaUrls } = mediaSlice.actions;
